module.exports = __webpack_public_path__ + "img/notas-enviadas.9c8cdcf5.png";